import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class ManagerResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/managers' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
